import { IValidation } from "./";

const Validation: IValidation = {
  error: "A senha deve ter entre 8 e 14 digitos",
  validate: (input: string) => input.length >= 8 && input.length < 14,
};

export default Validation;
